import gql from "graphql-tag";

export default gql`
  mutation changeSourceDisabledDewarp($sourceId: ID, $dewarpDisabled: Boolean) {
    changeSourceDisabledDewarp(sourceId: $sourceId, dewarpDisabled: $dewarpDisabled) {
      id
      dewarpDisabled
    }
  }
`;